export enum PermissionsEnum {
  // some modes but check as permission

  /** same that RA */
  RD = 'RA',
  /** same that RD */
  RA = 'RA',
  MBS = 'MBS',

  Provider = 'Provider',
  // end

  ADS = 'ADS',
  AccessToAllCompanies = 'AccessToAllCompanies',
  ActivateLicenseKey = 'ActivateLicenseKey',
  Administrator = 'Administrator',
  AssignTags = 'AssignTags',
  AuditLog = 'AuditLog',
  BackupHistory = 'BackupHistory',
  BackupHistory2024 = 'BackupHistory2024',
  Billing = 'Billing',
  CapacityReport = 'CapacityReport',
  CloudRestore = 'CloudRestore',
  CustomizeDashboard = 'CustomizeDashboard',
  Dashboard = 'Dashboard',
  DeepInstinct = 'DeepInstinct',
  DirectConnectAccess = 'DirectConnectAccess',
  Downloads = 'Downloads',
  EC2Snapshots = 'EC2Snapshots',
  GoogleApps = 'GoogleApps',
  HelpMarketing = 'HelpMarketing',
  LicenseBuy = 'LicenseBuy',
  LicenseUsageHistory = 'LicenseUsageHistory',
  Licenses = 'Licenses',
  ManageCompanies = 'ManageCompanies',
  ManageImmutability = 'ManageImmutability',
  ManageTags = 'ManageTags',
  Menu2022 = 'Menu2022',
  Monitoring = 'Monitoring',
  Notification = 'Notification',
  OnlineAccess = 'OnlineAccess',
  Package = 'Package',
  PSA = 'PSA',
  PurchaseHistory = 'PurchaseHistory',
  QuickRestore = 'QuickRestore',
  Rebranding = 'Rebranding',
  RemoteConnection = 'RemoteConnection',
  RemoteDeploy = 'RemoteDeploy',
  RemoteManagement = 'RemoteManagement',
  Rmm = 'Rmm',
  SecurityWidget = 'SecurityWidget',
  Storage = 'Storage',
  StorageUsage = 'StorageUsage',
  ShowDeepInstinct = 'ShowDeepInstinct',
  ShowDeepInstinctProvider = 'ShowDeepInstinctProvider',
  ShowRemoteConnection = 'ShowRemoteConnection',
  DeleteDataFromStorage = 'DeleteDataFromStorage',
  ShowRmm = 'ShowRmm',
  UseOldConnectSettings = 'UseOldConnectSettings',
  Users = 'Users',
  UsersCreateEdit = 'UsersCreateEdit',
  UsersDelete = 'UsersDelete',
  AllowPrePaymentLicensePage = 'AllowNewPrePaymentLicensePage',
  AllowUBObjectLock = 'AllowUBObjectLock'
}

// key - is allowed to show permission, values - are rules to show this permission
export const AdministratorPermissions: { readonly [key in PermissionsEnum]?: PermissionsEnum[] } = {
  [PermissionsEnum.ADS]: [],
  [PermissionsEnum.ActivateLicenseKey]: [],
  [PermissionsEnum.Administrator]: [],
  [PermissionsEnum.AssignTags]: [],
  [PermissionsEnum.AuditLog]: [],
  [PermissionsEnum.BackupHistory]: [],
  [PermissionsEnum.Billing]: [],
  [PermissionsEnum.CapacityReport]: [],
  [PermissionsEnum.CloudRestore]: [],
  [PermissionsEnum.CustomizeDashboard]: [],
  [PermissionsEnum.Dashboard]: [],
  [PermissionsEnum.DirectConnectAccess]: [],
  [PermissionsEnum.Downloads]: [],
  [PermissionsEnum.GoogleApps]: [],
  [PermissionsEnum.HelpMarketing]: [],
  [PermissionsEnum.LicenseBuy]: [],
  [PermissionsEnum.LicenseUsageHistory]: [],
  [PermissionsEnum.Licenses]: [],
  [PermissionsEnum.ManageCompanies]: [],
  [PermissionsEnum.ManageImmutability]: [],
  [PermissionsEnum.ManageTags]: [],
  [PermissionsEnum.Monitoring]: [],
  [PermissionsEnum.Notification]: [],
  [PermissionsEnum.OnlineAccess]: [],
  [PermissionsEnum.Package]: [],
  [PermissionsEnum.PSA]: [],
  [PermissionsEnum.PurchaseHistory]: [],
  [PermissionsEnum.QuickRestore]: [],
  [PermissionsEnum.Rebranding]: [],
  [PermissionsEnum.RemoteDeploy]: [],
  [PermissionsEnum.DeleteDataFromStorage]: [],
  [PermissionsEnum.RemoteManagement]: [],
  [PermissionsEnum.Storage]: [],
  [PermissionsEnum.StorageUsage]: [],
  [PermissionsEnum.ShowDeepInstinct]: [PermissionsEnum.ShowDeepInstinctProvider],
  [PermissionsEnum.ShowRemoteConnection]: [],
  [PermissionsEnum.UseOldConnectSettings]: [],
  [PermissionsEnum.Users]: [],
  [PermissionsEnum.UsersCreateEdit]: [],
  [PermissionsEnum.UsersDelete]: []
};
